function replaceStart(number) {

    if (number == null) {
        return "";
    }

    if (number.startsWith("07")) {
        return number.replace(/^(0)/, "44");
    }

    return '+' + number;
}

export {
    replaceStart
};